import * as React from "react"
import { LexicalText } from "@/schema"
import { OnChangePlugin } from "@lexical/react/LexicalOnChangePlugin"
import { EditorState, LexicalEditor } from "lexical"

import { toHTML, toMarkdown } from "@/components/lexical/serializer"

interface OnContentChangePluginProps {
  onSave?: (lexicalText: LexicalText) => void
  preferredFormat?: "html" | "markdown"
}

export default function OnContentChangePlugin({
  onSave,
  preferredFormat = "html",
}: OnContentChangePluginProps): React.JSX.Element {
  const handleChange = (editorState: EditorState, editor: LexicalEditor) => {
    editorState.read(() => {
      const nodes = editorState.toJSON()

      if (preferredFormat === "markdown") {
        const markdown = toMarkdown(editor)
        onSave?.({ nodes, markdown, preferred_format: "markdown" })
      } else {
        const html = toHTML(editor)
        onSave?.({ nodes, html, preferred_format: "html" })
      }
    })
  }

  return <OnChangePlugin onChange={handleChange} ignoreSelectionChange />
}
